import { render, staticRenderFns } from "./BaseInputPagination.vue?vue&type=template&id=427f8538&"
import script from "./BaseInputPagination.vue?vue&type=script&lang=js&"
export * from "./BaseInputPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports